import * as sdpTransform from 'sdp-transform';

export async function fixChromeEchoCancellationForAudioNode(context: AudioContext) {
  const destinationNode = context.createMediaStreamDestination();
  const inputPc = new RTCPeerConnection();
  const outputPc = new RTCPeerConnection();

  const masterTrackPlayerEl = new Audio();
  masterTrackPlayerEl.setAttribute('autoplay', 'autoplay');
  masterTrackPlayerEl.setAttribute('playsinline', 'playsinline');

  const onError = (e: any) => console.error('error', e);
  outputPc.addEventListener('icecandidate', e => e.candidate && inputPc.addIceCandidate(e.candidate).catch(onError));
  inputPc.addEventListener('icecandidate', e => e.candidate && outputPc.addIceCandidate(e.candidate).catch(onError));
  inputPc.addEventListener('track', e => masterTrackPlayerEl.srcObject = e.streams[0]);

  try {
    destinationNode.stream.getTracks().forEach(track => outputPc.addTrack(track, destinationNode.stream));

    const oldOffer = await outputPc.createOffer();

    if (oldOffer.sdp) {
      const parsedOffer = sdpTransform.parse(oldOffer.sdp);
      parsedOffer.media[0].fmtp[0].config = [
        ...parsedOffer.media[0].fmtp[0].config.split(';'),
        'sprop-stereo=1',
        'stereo=1',
      ].join(';');
      const newOffer = new RTCSessionDescription({ type: 'offer', sdp: sdpTransform.write(parsedOffer) });
      outputPc.setLocalDescription(newOffer);
      await inputPc.setRemoteDescription(newOffer);
  
      const oldAnswer = await inputPc.createAnswer();
      if (oldAnswer.sdp) {
        const parsedAnswer = sdpTransform.parse(oldAnswer.sdp);
        parsedAnswer.media[0].fmtp[0].config = [
          ...parsedAnswer.media[0].fmtp[0].config.split(';'),
          'sprop-stereo=1',
          'stereo=1',
        ].join(';');
        const newAnswer = new RTCSessionDescription({ type: 'answer', sdp: sdpTransform.write(parsedAnswer) });
        inputPc.setLocalDescription(newAnswer);
        outputPc.setRemoteDescription(newAnswer);
      }
    }
  } catch (e) {
    onError(e);
  }
}
